<template>
  <div id="app" class="app-background">
    
      <nav class="navbar navbar-expand-lg nav-bar-SL">
        <div class="container-fluid">
          <a href="#" class="navbar-brand"><img src="@/assets/vivaSpanishLogo.jpg" height="120" /></a>
              <button type="button" class="navbar-toggler" :class="visible ? null : 'collapsed'" 
          data-bs-toggle="collapse" 
          data-bs-target="#navContent" 
          aria-controls="navContent" 
          :aria-expanded="visible ? 'true' : 'false'"
          @click="visible = !visible" 
          aria-label="Toggle navigation" >
                <i class="pi pi-bars"></i>
              </button>
              <div class="collapse navbar-collapse" :class="!visible?'dontShow':''" id="navContent">
                  <div class="navbar-nav ">
                    <router-link to="/home" class="nav-item nav-link hvr-bounce-in">Home</router-link>
                    <router-link v-if="currentUser" to="/quizCategories" class="nav-item nav-link hvr-bounce-in">Quiz</router-link>
                    <router-link v-if="currentUser" to="/leaderBoard" class="nav-item nav-link hvr-bounce-in">Leaderboard</router-link>
                    <router-link v-if="currentUser" to="/leagues" class="nav-item nav-link hvr-bounce-in">Leagues</router-link>
                    <router-link v-if="currentUser" to="/battles" class="nav-item nav-link hvr-bounce-in">Battles</router-link>
                    <router-link v-if="showSchool" to="/school" class="nav-item nav-link hvr-bounce-in">School</router-link>
                    <router-link to="/contactus" class="nav-item nav-link hvr-bounce-in">Contact Us</router-link>
                  </div>
                    <div v-if="!currentUser" class="navbar-nav ms-auto">
                      <router-link to="/login" class="nav-item nav-link"><i class="pi pi-sign-in"></i> Login</router-link>
                      <router-link to="/register" class="nav-item nav-link"><i class="pi pi-user-plus"></i> Sign Up </router-link>
                    </div>
                    <div v-if="currentUser" class="navbar-nav ms-auto ">
                      <router-link to="/profile" class="nav-item nav-link hvr-bounce-in"> <i class="pi pi-user"></i> {{ currentUser.username }}</router-link>
                      <router-link v-if="showAdminBoard" to="/admin" class="nav-item nav-link hvr-bounce-in">Admin Board</router-link>
                      <a class="nav-item nav-link hvr-bounce-in" @click.prevent="logOut"><i class="pi pi-sign-out"></i></a>
                    </div>
                </div>
        </div>
      </nav>
    <div class="container hand-drawn-borders">
      
      <router-view />
    </div>
  </div>
  <footer>
  <div class="text-center p-3">
      ©
      <span>Spanish Lee Quiz</span>
    </div>
    <!-- Copyright -->
  </footer>
</template>
<script>
import { ref } from 'vue';
import UserService from "./services/user.service";
export default {
  setup() {
    const visible = ref(false);
    return { visible };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
    showAdminBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_ADMIN');
      }

      return false;
    },
    showModeratorBoard() {
      if (this.currentUser && this.currentUser['roles']) {
        return this.currentUser['roles'].includes('ROLE_MODERATOR');
      }

      return false;
    },
    showSchool() {
      if (this.currentUser && this.currentUser['schoolId']!=0) {
        return true
      }

      return false;
    }
  },
  methods: {
    logOut() {
      this.$store.dispatch('auth/logout');
      this.$router.push('/login');
    }
  },
  mounted() {
    console.log(this.$route.name);
    if (!this.currentUser) {
      return;
    }
    UserService.userProfile(this.$store.state.auth.user.id).then(
        (response) => {
          console.log(response.status);
        },
        (error) => {
          this.content =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          const status = error.response && error.response.status;
          if (status === 401 || status === 403) {
            this.logOut();
          }
        }
      );
  }
};
</script>
<style lang="css">
.dontShow {
  display: none!important;
}
</style>